import {Button, Col, Row} from "react-bootstrap";
import FilterListIcon from '@material-ui/icons/FilterList';
import FilterModal from "./FilterModal";
import {useState} from "react";

export default function SubHeader({numberPOs,totalCostFCFA,  totalCost, onFilterChange}) {
    const [isFilterModalShown, setIsFilterModalShown] = useState(false);

    const handleFilterModalShowing = () => {
        setIsFilterModalShown(true)
    }
 
    const handleFilterModalClosing = () => {
        setIsFilterModalShown(false)
    };

    const handleFilterChange = (filter) => {
        onFilterChange && onFilterChange(filter)
    }

    return (
        <section style={{marginTop:0}}>
            <Row className=''>

                <Col>
                    <Row>
                        <h6>
                            Total Po: {numberPOs && numberPOs}
                        </h6>
                    </Row>
                    
                    <div style={{margin: 5}}/>

                    <Row>
                        <h6>
                            Total Amount: {totalCost && `$ ${totalCost}`}
                        </h6> 
                    </Row>
                    <div style={{margin: 5}}/>

                    <Row>
                        <h6>
                            Total Amount FCFA: {totalCostFCFA && `${totalCostFCFA} F CFA`}
                        </h6>
                    </Row>

                </Col>

                <Col className='col-auto ml-auto'>
                    <Button onClick={handleFilterModalShowing}>
                        <FilterListIcon/>
                        {' Filter'}
                    </Button>

                </Col>

            </Row>

            <FilterModal
                show={isFilterModalShown}
                onSet={handleFilterChange}
                onClose={handleFilterModalClosing}
            />

        </section>
    )
}
